import { render, staticRenderFns } from "./LeaveAllowanceGroupInput.vue?vue&type=template&id=6f13c6ff"
import script from "./LeaveAllowanceGroupInput.vue?vue&type=script&lang=js"
export * from "./LeaveAllowanceGroupInput.vue?vue&type=script&lang=js"
import style0 from "./LeaveAllowanceGroupInput.vue?vue&type=style&index=0&id=6f13c6ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports